<p-toast></p-toast>

<button
  pButton
  pRipple
  icon="pi pi-shopping-cart"
  class="p-button-rounded p-button-primary mr-2"
  (click)="open = true"
  pTooltip="Carrito"
  tooltipPosition="left"
  [disabled]="isCartEmpty()"
></button>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  [style]="{ width: '100%' }"
  (onHide)="onClose()"
>
  <div class="flex justify-content-end">
    <div class="flex align-items-center mr-4 mb-4">
      <div class="text-base">Total Venta:</div>
      <div class="text-xl font-semibold">&nbsp;S/. {{ amountSale }}</div>
    </div>
  </div>

  <ami-table-expansion
    [settings]="table.settings"
    [data]="table.data"
    [childSettings]="tableChild.settings"
    [childActions]="tableChild.actions"
    (childAction)="onReciveActionChild($event)"
  >
  </ami-table-expansion>
</p-dialog>

<div *ngIf="openSideBar">
  <pg-product-sale-sidebar
    type="update"
    [item]="itemToSideBar"
    (close)="openSideBar = false"
  ></pg-product-sale-sidebar>
</div>

<p-dialog
  *ngIf="openConfirmRemove"
  [(visible)]="openConfirmRemove"
  header="Confirmar Eliminación"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="flex align-items-center justify-content-center">
    <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"></i>
    <span>¿Está seguro de que desea remover el producto del carrito?</span>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      icon="pi pi-times"
      class="p-button-text"
      label="No"
      (click)="openConfirmRemove = false"
      pTooltip="Cancelar"
      tooltipPosition="bottom"
    ></button>
    <button
      pButton
      pRipple
      icon="pi pi-check"
      class="p-button-text"
      label="Si"
      (click)="removeItemCart()"
      pTooltip="Remover Producto"
      tooltipPosition="bottom"
    ></button>
  </ng-template>
</p-dialog>
